export default {
    namespaced: true,
	state: {
		readyStat:true
    },
    getters: {
        getReady(state) {
            return state.readyStat
        }
    },
    mutations: {
        setReady(state) {
            state.readyStat = false;
        }
    },
    actions: {
        statReady (store) {
            store.commit('setReady');
        }
    }
}